export const VIDEO_RECORDING = {
  STANDBY_CYCLE_MS: 3000,
  POSTROLL_DELAY_MS: 1000,

  MAX_RETRY_ATTEMPTS: 3,
  RETRY_BASE_DELAY_MS: 1000,
  UPLOAD_TIMEOUT_MS: 60000,

  VIDEO_CONSTRAINTS: {
    width: { ideal: 1280 },
    height: { ideal: 720 },
    frameRate: { ideal: 15 },
  },

  MIME_TYPES: ['video/webm;codecs=vp9', 'video/webm;codecs=vp8', 'video/webm'],
};

export function getSupportedMimeType() {
  if (typeof MediaRecorder === 'undefined') return null;
  return (
    VIDEO_RECORDING.MIME_TYPES.find(type =>
      MediaRecorder.isTypeSupported(type),
    ) || null
  );
}
